<template>
    <div class="active-filters-section" v-if="hasActiveFilters">
        <div class="filters-tags-wrapper">
            <!-- Zone des chips scrollable si > 10 filtres -->
            <div class="filters-chips-container" :class="{ 'scrollable': activeFiltersCount > 10 }">
                <!-- Tags pour les filtres de type tableau -->
                <FilterChip
                    v-for="value in filter.type"
                    :key="`type-${value}`"
                    @remove="$emit('remove-filter', 'type', value)"
                >
                    Type: {{ value }}
                </FilterChip>

                <FilterChip
                    v-for="value in filter.marque"
                    :key="`marque-${value}`"
                    @remove="$emit('remove-filter', 'marque', value)"
                >
                    Marque: {{ value }}
                </FilterChip>

                <FilterChip
                    v-for="value in filter.modele"
                    :key="`modele-${value}`"
                    @remove="$emit('remove-filter', 'modele', value)"
                >
                    Modèle: {{ value }}
                </FilterChip>

                <FilterChip
                    v-for="value in filter.energie"
                    :key="`energie-${value}`"
                    @remove="$emit('remove-filter', 'energie', value)"
                >
                    Carburant: {{ value }}
                </FilterChip>

                <FilterChip
                    v-for="value in filter.vitesse"
                    :key="`vitesse-${value}`"
                    @remove="$emit('remove-filter', 'vitesse', value)"
                >
                    Boîte: {{ value }}
                </FilterChip>

                <FilterChip
                    v-for="value in filter.places"
                    :key="`places-${value}`"
                    @remove="$emit('remove-filter', 'places', value)"
                >
                    Places: {{ value }}
                </FilterChip>

                <!-- Tags pour les filtres simples -->
                <FilterChip
                    v-if="filter.price_min !== null && filter.price_min !== '' && filter.price_min !== 0"
                    @remove="$emit('remove-simple-filter', 'price_min')"
                >
                    Prix min: {{ formatPrice(filter.price_min) }}
                </FilterChip>

                <FilterChip
                    v-if="filter.price_max !== null && filter.price_max !== '' && filter.price_max !== 0"
                    @remove="$emit('remove-simple-filter', 'price_max')"
                >
                    Prix max: {{ formatPrice(filter.price_max) }}
                </FilterChip>

                <FilterChip
                    v-if="filter.kms_min !== null && filter.kms_min !== '' && filter.kms_min !== 0"
                    @remove="$emit('remove-simple-filter', 'kms_min')"
                >
                    Kms min: {{ formatMileage(filter.kms_min) }}
                </FilterChip>

                <FilterChip
                    v-if="filter.kms_max !== null && filter.kms_max !== '' && filter.kms_max !== 0"
                    @remove="$emit('remove-simple-filter', 'kms_max')"
                >
                    Kms max: {{ formatMileage(filter.kms_max) }}
                </FilterChip>

                <FilterChip
                    v-if="filter.year_min !== null && filter.year_min !== '' && filter.year_min !== 0"
                    @remove="$emit('remove-simple-filter', 'year_min')"
                >
                    Année min: {{ filter.year_min }}
                </FilterChip>

                <FilterChip
                    v-if="filter.year_max !== null && filter.year_max !== '' && filter.year_max !== 0"
                    @remove="$emit('remove-simple-filter', 'year_max')"
                >
                    Année max: {{ filter.year_max }}
                </FilterChip>

                <FilterChip
                    v-if="filter.reliable === true || filter.reliable === 'true'"
                    @remove="$emit('remove-simple-filter', 'reliable')"
                >
                    Fiable ou remboursé
                </FilterChip>
            </div>

            <!-- Zone droite : Compteur + Bouton Tout effacer -->
            <div class="filters-actions">
                <span class="filters-count">
                    Filtres sélectionnés : <strong>{{ activeFiltersCount }}</strong>
                </span>
                <button @click="$emit('clear-all-filters')" class="clear-all-btn" aria-label="Tout effacer">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    </svg>
                    Tout effacer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {formatMileage} from "@/helpers/format-mileage";
import {formatPrice} from "@/helpers/format-price";
import FilterChip from '@/Components/FilterChip';

export default {
    components: {
        FilterChip
    },
    props: {
        filter: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {
            formatMileage,
            formatPrice,
        }
    },
    computed: {
        hasActiveFilters() {
            return this.filter.type.length > 0
                || this.filter.marque.length > 0
                || this.filter.modele.length > 0
                || this.filter.energie.length > 0
                || this.filter.vitesse.length > 0
                || this.filter.places.length > 0
                || (this.filter.price_min !== null && this.filter.price_min !== '' && this.filter.price_min !== 0)
                || (this.filter.price_max !== null && this.filter.price_max !== '' && this.filter.price_max !== 0)
                || (this.filter.kms_min !== null && this.filter.kms_min !== '' && this.filter.kms_min !== 0)
                || (this.filter.kms_max !== null && this.filter.kms_max !== '' && this.filter.kms_max !== 0)
                || (this.filter.year_min !== null && this.filter.year_min !== '' && this.filter.year_min !== 0)
                || (this.filter.year_max !== null && this.filter.year_max !== '' && this.filter.year_max !== 0)
                || (this.filter.reliable === true || this.filter.reliable === 'true');
        },
        activeFiltersCount() {
            let count = 0;
            count += this.filter.type.length;
            count += this.filter.marque.length;
            count += this.filter.modele.length;
            count += this.filter.energie.length;
            count += this.filter.vitesse.length;
            count += this.filter.places.length;
            if (this.filter.price_min !== null && this.filter.price_min !== '' && this.filter.price_min !== 0) count++;
            if (this.filter.price_max !== null && this.filter.price_max !== '' && this.filter.price_max !== 0) count++;
            if (this.filter.kms_min !== null && this.filter.kms_min !== '' && this.filter.kms_min !== 0) count++;
            if (this.filter.kms_max !== null && this.filter.kms_max !== '' && this.filter.kms_max !== 0) count++;
            if (this.filter.year_min !== null && this.filter.year_min !== '' && this.filter.year_min !== 0) count++;
            if (this.filter.year_max !== null && this.filter.year_max !== '' && this.filter.year_max !== 0) count++;
            if (this.filter.reliable === true || this.filter.reliable === 'true') count++;
            return count;
        }
    },
    emits: ['remove-filter', 'remove-simple-filter', 'clear-all-filters']
}
</script>

<style scoped lang="scss">
.active-filters-section {
    padding: 0;
    display: flex;
    justify-content: center;
    width: 100%;

    .filters-tags-wrapper {
        margin-bottom: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        padding: 18px 35px;
        background: rgba(255, 255, 255, 0.15);
        border: 1px solid rgba(255, 255, 255, 0.4);
        border-radius: 60px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12),
                    inset 0 1px 0 rgba(255, 255, 255, 0.6);
        backdrop-filter: blur(5px) saturate(200%);
        -webkit-backdrop-filter: blur(5px) saturate(200%);
        max-width: 100%;

        // Animation d'apparition
        animation: slideInUp 0.4s ease-out;

        @keyframes slideInUp {
            from {
                opacity: 0;
                transform: translateY(20px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }

    .filters-chips-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
        flex: 1;
        max-height: 80px;
        overflow: hidden;

        &.scrollable {
            max-height: 80px;
            overflow-y: auto;
            padding-right: 10px;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(0, 0, 0, 0.05);
                border-radius: 10px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(255, 140, 0, 0.5);
                border-radius: 10px;

                &:hover {
                    background: rgba(255, 140, 0, 0.7);
                }
            }
        }
    }


    .filters-actions {
        display: flex;
        align-items: center;
        gap: 15px;
        flex-shrink: 0;
    }

    .filters-count {
        font-size: 14px;
        color: #333;
        white-space: nowrap;
        font-weight: 400;

        strong {
            color: #ff8c00;
            font-weight: 700;
            font-size: 16px;
        }
    }

    .clear-all-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #ff8c00;
        color: white;
        border: none;
        border-radius: 30px;
        padding: 10px 20px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
        box-shadow: 0 4px 12px rgba(255, 140, 0, 0.25);

        svg {
            width: 16px;
            height: 16px;
        }

        &:hover {
            background: #e67e00;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(255, 140, 0, 0.35);
        }

        &:active {
            transform: translateY(0);
            box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);
        }
    }
}

@media screen and (max-width: 1024px) {
    .active-filters-section {
        .filters-tags-wrapper {
            padding: 16px 25px;
            gap: 15px;
            flex-wrap: wrap;
        }

        .filters-chips-container {
            width: 100%;
            max-height: 70px;
        }

        .filters-actions {
            width: 100%;
            justify-content: space-between;
            padding-top: 10px;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
        }
    }
}

@media screen and (max-width: 768px) {
    .active-filters-section {
        margin-top: 15px;

        .filters-tags-wrapper {
            padding: 14px 20px;
            gap: 12px;
            border-radius: 40px;
            flex-direction: column;
            align-items: stretch;
        }

        .filters-chips-container {
            max-height: 60px;
            gap: 8px;

            &.scrollable {
                max-height: 60px;
            }
        }


        .filters-actions {
            width: 100%;
            justify-content: space-between;
            padding-top: 10px;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            gap: 10px;
        }

        .filters-count {
            font-size: 12px;

            strong {
                font-size: 14px;
            }
        }

        .clear-all-btn {
            font-size: 12px;
            padding: 8px 16px;
            border-radius: 25px;

            svg {
                width: 14px;
                height: 14px;
            }
        }
    }
}
</style>
